/**
 * @fileoverview Agent definition for single-chapter-story-generator-v2.
 *
 * Generates a complete story arc contained within a single chapter outline.
 *
 * @category narrative.chapters.scenes
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'single-chapter-story-generator-v2',
  kind: 'primitive',
  name: 'Single Chapter Story Generator',
  description: 'Generates a complete story arc contained within a single chapter outline.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.scenes',
    usedBy: [
      'primitives/use-single-chapter-story-generator-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'scene-architect-v2',
    ],
  },
};
